export default "__VITE_ASSET__CdGj0xJh__"